"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IExternalComponentAssignmentSchema = void 0;
const zod_1 = require("zod");
const zod_field_presence_1 = require("../Utils/zod-field-presence");
exports.IExternalComponentAssignmentSchema = zod_1.z.object({
    assignment: zod_1.z.string(),
    traversals: (0, zod_field_presence_1.allowingAbsentKey)(zod_1.z.custom()),
});
//# sourceMappingURL=IExternalComponentAssignment.js.map